import { render, staticRenderFns } from "./reportForm.vue?vue&type=template&id=38aa2bb2&scoped=true&"
import script from "./reportForm.vue?vue&type=script&lang=js&"
export * from "./reportForm.vue?vue&type=script&lang=js&"
import style0 from "./reportForm.vue?vue&type=style&index=0&id=38aa2bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa2bb2",
  null
  
)

export default component.exports